import { useTranslation } from "react-i18next";
import { usePWARegister } from "../../pwa/registerSW";

const UPDATE_DISMISSED_KEY = "pwa-update-dismissed-for-session";

function wasDismissedForSession(): boolean {
  try {
    return window.sessionStorage.getItem(UPDATE_DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
}

function dismissForSession() {
  try {
    window.sessionStorage.setItem(UPDATE_DISMISSED_KEY, "true");
  } catch {
    // Ignore storage failures; the in-memory PWA state is still cleared below.
  }
}

function clearDismissal() {
  try {
    window.sessionStorage.removeItem(UPDATE_DISMISSED_KEY);
  } catch {
    // Ignore storage failures; updateServiceWorker still controls the refresh.
  }
}

export function UpdateAvailableBanner() {
  const { t } = useTranslation("pwa");
  const { needRefresh, updateServiceWorker, setNeedRefresh } = usePWARegister();

  if (!needRefresh || wasDismissedForSession()) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed bottom-0 start-0 end-0 z-50 flex items-center justify-between gap-3 border-t border-border bg-background px-4 py-3 shadow-lg"
    >
      <div className="flex min-w-0 flex-col">
        <span className="text-sm font-semibold text-foreground">
          {t("update_available.title")}
        </span>
        <span className="text-xs text-muted-foreground">
          {t("update_available.description")}
        </span>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={() => {
            dismissForSession();
            setNeedRefresh(false);
          }}
          className="min-h-[44px] rounded-md px-3 py-2 text-sm text-muted-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t("update_available.cta_later")}
        </button>
        <button
          type="button"
          onClick={() => {
            clearDismissal();
            void updateServiceWorker(true);
          }}
          className="min-h-[44px] rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t("update_available.cta_update")}
        </button>
      </div>
    </div>
  );
}
